import { useEffect, useState } from 'react';

export const isTouchDevice = ({ navigator }: { navigator: Navigator }): boolean => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const useTouchScreen = (): { isSupported: boolean } => {
  const [isSupported, setIsSupported] = useState(false);
  useEffect(() => {
    if (isTouchDevice({ navigator })) {
      setIsSupported(true);
    }
  }, []);
  return { isSupported };
};
